/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const SpeechPlus = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16" fill="none">
      <g>
        <path d="M12.5 8.5H15.5" stroke={props?.color || "white"} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 7V10" stroke={props?.color || "white"} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M6.75 10C8.82107 10 10.5 8.32107 10.5 6.25C10.5 4.17893 8.82107 2.5 6.75 2.5C4.67893 2.5 3 4.17893 3 6.25C3 8.32107 4.67893 10 6.75 10Z"
          stroke={props?.color || "white"}
          strokeMiterlimit="10"
        />
        <path
          d="M1.38745 12.5007C2.04449 11.7176 2.86506 11.0879 3.79149 10.6559C4.71792 10.2239 5.72774 10 6.74995 10C7.77217 10 8.78198 10.2239 9.70841 10.6559C10.6348 11.0879 11.4554 11.7176 12.1125 12.5007"
          stroke={props?.color || "white"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </BaseSvgIcon>
  )
}

export default SpeechPlus
